<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i class="fa fa-times" (click)="cancel()" style="cursor: pointer;"></i>
  </div>
</div>
<div class="modal-body" [hidden]="minimise">
  <form novalidate autocomplete="off">
    <div class="form-group">
      <label class="control-label"><strong>Current Year Reporting Currency:</strong></label>
      <select class="form-control" [(ngModel)]="selected_currency" name="currency" (ngModelChange)="changeCurrency()" required>
        <option [ngValue]="null" disabled>Select</option>
        @for (c of currencies; track $index) {
<option [ngValue]="c">{{ c.CURR }} - {{ c.CURR_DESC }}</option>
}
      </select>
    </div>
    <div class="form-group">
      <label class="control-label"><strong>Prior to Current Exchange Rate:</strong></label>
      <label>{{ selected_curr_exg_rate | number:'1.0-6' }}</label>
    </div>
    <div class="form-group">
      <label class="control-label"><strong>Select Scenario to Populate Balances:</strong></label>
      <select class="form-control" [(ngModel)]="selected_scenario" name="scenario" required>
        <option [ngValue]="null" disabled>Select</option>
        @for (s of scenarios; track $index) {
<option [ngValue]="s">{{ s.TAX_YEAR }} - {{ s.SCENARIO_DESC }}</option>
}
      </select>
    </div>
  </form>
</div>
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
